import React from 'react';
import { LineItemsOption, } from '@wix/ambassador-crm-financials-v2-invoice-template/types';
import s from './PriceQuoteView.scss';
import isEmpty from 'lodash.isempty';
import { Text, WixDesignSystemProvider } from '@wix/design-system';
import LineItems from '../DocParts/LineItems';
import Totals from './Totals';
import Customer from './Customer';
import Comments from '../DocParts/Comments';
import { PriceQuotesBusinessInfo } from '../DocParts/PriceQuotesBusinessInfo/PriceQuotesBusinessInfo';
import QuoteInfo from './QuoteInfo';
import Status from './Status';
import AscendLogo from '../AscendLogo';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { WithTitleLoader } from '../loaders/loaders-builder';
import { withProvider } from '../../i18n';
import '@wix/design-system/styles.global.css';
import { parseFromHtmlString } from '../../utils/parsing';
const Title = WithTitleLoader(({ priceQuote }) => (React.createElement("div", { className: s.title },
    React.createElement(Text, { dataHook: "price-quote-title", weight: "bold", size: "tiny" }, priceQuote.title))));
const PriceQuoteView = ({ priceQuote, businessInfo, locale, isUoU = false, ascend = false, t, tReady, onQuotePreviewReady, primarySiteLocale, invoiceTemplate, features, }) => {
    const [businessInfoReady, setBusinessInfoReady] = React.useState(false);
    const [quoteReady, setQuoteReady] = React.useState(false);
    React.useEffect(() => {
        !!businessInfo && !isEmpty(businessInfo) && setBusinessInfoReady(true);
        !!priceQuote && !isEmpty(priceQuote) && setQuoteReady(true);
    }, [businessInfo, priceQuote]);
    const showTaxedLineTotals = invoiceTemplate?.lineItemsSettings?.lineItemsOptions?.includes(LineItemsOption.SHOW_TAX) ?? false;
    const lineItems = (priceQuote.lineItems?.lineItems ?? []).map(({ name, description, price, quantity, taxes, taxedTotal }) => {
        const lineItemQuantity = quantity?.serializedValue || 0;
        const lineItemPrice = price?.serializedValue || 0;
        const lineItemTotal = lineItemQuantity * lineItemPrice;
        const taxedLineItemTotal = taxedTotal?.serializedValue || 0;
        return {
            name: name ?? '',
            description: parseFromHtmlString(description, ''),
            price: lineItemPrice,
            quantity: lineItemQuantity,
            total: showTaxedLineTotals && features.enableTaxedLineTotals
                ? taxedLineItemTotal
                : lineItemTotal,
            taxes: taxes ?? [],
        };
    });
    if (!tReady) {
        return null;
    }
    return (React.createElement(WixDesignSystemProvider, { features: { newColorsBranding: true } },
        React.createElement("div", null,
            React.createElement("div", { className: s.priceQuoteView },
                React.createElement("div", { className: s.details },
                    React.createElement("div", { className: s.detail },
                        React.createElement(PriceQuotesBusinessInfo, { businessInfo: businessInfo, onImageReady: onQuotePreviewReady, isReady: businessInfoReady }),
                        React.createElement(Title, { priceQuote: priceQuote, isReady: quoteReady }),
                        React.createElement(Customer, { isReady: quoteReady, customer: priceQuote.customer })),
                    React.createElement("div", { className: s.detail },
                        React.createElement(Status, { isReady: quoteReady, status: priceQuote.status, isUoU: isUoU }),
                        React.createElement(QuoteInfo, { isReady: quoteReady, priceQuote: priceQuote, locale: locale, primarySiteLocale: primarySiteLocale }))),
                React.createElement(LineItems, { lineItems: lineItems, currencyCode: priceQuote.currencyCode ?? 'USD', locale: locale, showTaxColumn: features.enableTaxedLineTotals && showTaxedLineTotals, tableStyle: features.enableTaxedLineTotals ? 'grid' : 'legacy' }),
                React.createElement(Totals, { priceQuote: priceQuote, locale: locale }),
                React.createElement(Comments, { metaData: priceQuote.metaData }),
                ascend && (React.createElement("div", { className: s.ascendFooter, "data-hook": "ascend-footer" },
                    React.createElement(Text, { weight: "normal", size: "tiny", secondary: true }, t('invoice-view:price-quote.created-with')),
                    React.createElement("div", { className: s.ascendLogo },
                        React.createElement(AscendLogo, null))))))));
};
const PriceQuoteViewT = withTranslation(['invoice-view', 'locale-data'])(PriceQuoteView);
export default PriceQuoteViewT;
export const PriceQuoteViewFull = withProvider(PriceQuoteViewT);
//# sourceMappingURL=PriceQuoteView.js.map